import { render, staticRenderFns } from "./payDetail.vue?vue&type=template&id=72bd72e5&"
import script from "./payDetail.vue?vue&type=script&lang=js&"
export * from "./payDetail.vue?vue&type=script&lang=js&"
import style0 from "./payDetail.vue?vue&type=style&index=0&id=72bd72e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports